import { type ReactNode } from 'react';
import { useSpring, animated, config } from '@react-spring/web';
import { useMedia } from 'react-use';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import styles from './QuizQuestionHeading.module.css';

interface Props {
  hero: ReactNode;
  subcopy?: ReactNode;
  toolTip?: ReactNode;
  className?: string;
  testid?: string;
}

export function QuizQuestionHeading(props: Props) {
  const { className, hero, subcopy, toolTip, testid } = props;
  const isDesktop = useMedia(BreakpointQueryLarge, false);
  const spring = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    config: config.stiff,
  });
  return (
    <div
      data-testid={testid}
      className={`${styles['question-section']} ${className}`}
    >
      <animated.div style={spring}>
        {hero}
        {subcopy && (
          <div className={styles['question-section-subcopy']}>{subcopy}</div>
        )}
        {isDesktop && toolTip}
      </animated.div>
    </div>
  );
}
